import React from 'react';
import styles from './styles.module.scss';
import { Tooltip, Button } from 'components/antd';
import classNames from 'classnames';

interface Props {
	providerName: string;
	providerDescription?: string;
	isSelected: boolean;
	disableTermsAndConditions?: boolean;
	termsAndConditionsHandler?: (bookingPriceId: number) => void;
	bookingPriceId?: number;
	setTermsAndConditionsAcceptModalType?: (acceptModalType: boolean) => void;
}
export const ProviderRow: React.FC<Props> = props => {
	const {
		providerName,
		providerDescription,
		isSelected,
		children,
		disableTermsAndConditions,
		termsAndConditionsHandler,
		bookingPriceId,
		setTermsAndConditionsAcceptModalType,
	} = props;
	return (
		<div
			className={classNames(styles.providerItem, {
				[styles.providerItemActive]: isSelected,
			})}
		>
			<div>
				<Tooltip title={providerDescription} placement="bottomLeft">
					<span className={styles.providerName}>{providerName}</span>
				</Tooltip>
				<Button
					onClick={() => {
						termsAndConditionsHandler && termsAndConditionsHandler(bookingPriceId!);
						setTermsAndConditionsAcceptModalType &&
							setTermsAndConditionsAcceptModalType(false);
					}}
					isLink
					subType="simpleLink"
					disabled={disableTermsAndConditions}
				>
					Terms &#38; Conditions
				</Button>
			</div>
			<div className={styles.providerColumnLast}>{children}</div>
		</div>
	);
};
